import { Component, OnInit, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { Http } from '@angular/http';
import { NotificationService } from 'src/app/shared/notification.service';
import { ApiService } from 'src/app/shared/api.service';
import { Headers, RequestOptions } from '@angular/http';
import { CandidateService } from 'src/app/shared/candidate.service';
import { GlobalConstantsService } from 'src/app/shared/global-constants.service';


@Component({
  selector: 'app-upload-excel',
  templateUrl: './upload-excel.component.html',
  styleUrls: ['./upload-excel.component.scss']
})
export class UploadExcelComponent implements OnInit {
  
  updateCandiateList = new EventEmitter();

  constructor(private http: Http,
              private notificationService: NotificationService,
              public dialogRef: MatDialogRef<UploadExcelComponent>,
              private service: CandidateService,
              private apiService: ApiService) { }

  ngOnInit() { }

  isSingleUploaded = false;
  private apiDomain = ApiService.getDomainName();
  private eventId = this.apiService.getEventId();
  onClose() {
    this.dialogRef.close();
  }
  csvInputChange(files) {
    // var files = fileInputEvent.target.files; // FileList object
    if(!(files[0].name.indexOf(".xlsx") > 0)){
      this.notificationService.warn('Only .xlsx & .xls extensions file can be acceptable');
      return false;
    }
    this.parseExcel(files[0]);
  }

  parseExcel(file) {
    var reader = new FileReader();
    reader.onload = (e) => {
      var data = (<any>e.target).result;
      var workbook = XLSX.read(data, {
        type: 'binary'
      });
      workbook.SheetNames.forEach((function (sheetName) {
        // Here is your object
        var XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { raw: false });
        // var json_object = JSON.stringify(XL_row_object);

        if (XL_row_object &&
            Array.isArray(XL_row_object) &&
            (XL_row_object.length > 0)
          ) {
            const candidateXLVariableObjectList: Array<JSON> | null = GlobalConstantsService.XLTitleVariableMapper(XL_row_object, 'CANDIDATE');
            this.service.createCandidate(candidateXLVariableObjectList).then(
              res => {
                const { listOfRejectedCandidates, listOfSavedCandidates, message } = res && res.data;
                this.updateCandiateList.emit(listOfSavedCandidates);
                this.notificationService.success(message || 'File Successfully Uploaded');
                this.onClose();
              },
              err => {
                try {
                  const { data, errors } = err;
                  const { listOfRejectedCandidates } = data;

                  errors.forEach(errorObj => {
                    const { message } = errorObj;
                    this.notificationService.warn(message || 'Failed to upload');
                  });
                  
                  listOfRejectedCandidates.forEach(candidateObj => {
                    candidateObj.listOfErrorMessageAssociated.forEach(errorMessage => {
                      this.notificationService.warn(errorMessage);
                    })
                  });

                } catch (error) {
                  const errMessage = 'Failed to upload';
                  this.notificationService.warn(errMessage);
                }
                return false;
              }
            );
          } else {
            console.debug(XL_row_object);
            this.notificationService.warn('XLSX format is not proper.');
          }

        // console.log(json_object)
        //this.gridObj.dataSource = JSON.parse(json_object);
      }).bind(this), this);
    }

    reader.onerror = function (ex) {
      console.log(ex);
    }
    reader.readAsBinaryString(file);
    console.log
  }

  createCandidate(json_object) {
    let candidateHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.post(this.apiDomain + "/ims/api/" + this.eventId + "/candidate/", json_object, { headers: candidateHeaders })
      .toPromise()
      .then(response => response as any)
      .catch(this.handleError);
  }
  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }

}
